
export default function CaseStudiesSection() {
  const caseStudies = [
    {
      company: "Global Electronics Manufacturer",
      industry: "Electronics",
      problem: "High injury rates in repetitive assembly tasks, 40% worker turnover due to ergonomic issues",
      solution: "Deployed 15 humanoid robots for precision assembly with collaborative safety systems",
      outcome: "92% reduction in workplace injuries, 65% increase in production throughput, 18-month ROI",
      image: "https://public.readdy.ai/ai/img_res/fdcb6a41f8170393d9311a96668d2e33.jpg"
    },
    {
      company: "Major Logistics Provider",
      industry: "3PL Logistics",
      problem: "Forklift accidents causing $2M annual losses, inefficient pallet handling during peak seasons",
      solution: "Implemented fleet of 25 AMR/AGF robotic forklifts with AI-powered traffic management",
      outcome: "Zero forklift accidents in 18 months, 45% faster order fulfillment, 280% ROI achieved",
      image: "https://readdy.ai/api/search-image?query=Large%20logistics%20warehouse%20case%20study%20showing%20autonomous%20robotic%20forklifts%20safely%20operating%2C%20improved%20traffic%20flow%2C%20safety%20metrics%20dashboard%2C%20successful%20warehouse%20automation%20implementation&width=400&height=250&seq=case2-001&orientation=landscape"
    },
    {
      company: "Automotive Parts Distributor",
      industry: "Manufacturing",
      problem: "Manual inventory management errors, safety concerns in high-traffic warehouse areas",
      solution: "BC Robotics safety & deployment services with phased automation rollout and staff training",
      outcome: "99.8% inventory accuracy, 70% reduction in safety incidents, seamless workforce transition",
      image: "https://readdy.ai/api/search-image?query=Automotive%20parts%20warehouse%20transformation%2C%20before%20and%20after%20comparison%20showing%20improved%20safety%20systems%2C%20organized%20robotic%20inventory%20management%2C%20successful%20deployment%20case%20study&width=400&height=250&seq=case3-001&orientation=landscape"
    }
  ];

  return (
    <section id="case-studies" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Proven Results</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real-world case studies demonstrating measurable safety improvements, 
            productivity gains, and return on investment across diverse industries.
          </p>
        </div>
        
        <div className="space-y-12">
          {caseStudies.map((study, index) => (
            <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
              <div className={`${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8">
                  <div className="flex items-center mb-4">
                    <div className="text-sm font-semibold text-blue-600 bg-blue-100 px-3 py-1 rounded-full">
                      {study.industry}
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">{study.company}</h3>
                  
                  <div className="space-y-4">
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-error-warning-line text-red-500 mr-2 w-4 h-4 flex items-center justify-center"></i>
                        Challenge
                      </h4>
                      <p className="text-gray-600 leading-relaxed">{study.problem}</p>
                    </div>
                    
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-lightbulb-line text-blue-500 mr-2 w-4 h-4 flex items-center justify-center"></i>
                        Solution
                      </h4>
                      <p className="text-gray-600 leading-relaxed">{study.solution}</p>
                    </div>
                    
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-trophy-line text-green-500 mr-2 w-4 h-4 flex items-center justify-center"></i>
                        Results
                      </h4>
                      <p className="text-gray-600 leading-relaxed font-medium">{study.outcome}</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className={`${index % 2 === 1 ? 'lg:col-start-1' : ''}`}>
                <img 
                  src={study.image} 
                  alt={`${study.company} Case Study`}
                  className="w-full h-80 rounded-2xl shadow-lg object-cover object-top"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
